import type { SvgProps } from 'react-native-svg';
import { Circle, Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface ExclamationMarkIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const ExclamationMarkIcon = ({
  size = 12,
  color = 'iconPrimary',
  ...props
}: ExclamationMarkIconProps) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 12 12" fill="none" {...props}>
      <Path d="M6 0V7.5" stroke={colors[color]} strokeWidth={2} />
      <Circle cx="6" cy="11" r="1" fill={colors[color]} />
    </Svg>
  );
};

ExclamationMarkIcon.displayName = 'ExclamationMarkIcon';
export { ExclamationMarkIcon };
